export default "__VITE_ASSET__Bn1RO3m8__"